import React, { useCallback } from 'react'
import s from './education-setting.module.scss'
import { SettingRow } from '../setting-row/setting-row'
import classNames from 'classnames'
import { queryClient } from '@shared/api/query-client'
import { useDropzone } from 'react-dropzone'
import { IconPaperclip, IconX } from '@tabler/icons-react';
import { Button } from '@shared/ui/button/button'
import { useAttachFileModal } from '@features/attach-files'

const MAX_FILES = 5;

export const EducationSetting = ({setMyFiles, setGlobalFiles, myFiles, globalFiles, info_verified}) => {
	const {data: profile} = queryClient.getQueryData(['profile'])
	const { open: openAttachFileModal } = useAttachFileModal();

	const totalFiles = myFiles.length + globalFiles.length;

	const onDrop = useCallback(
		(acceptedFiles) => {
			setMyFiles([...myFiles, ...acceptedFiles]);
		},
		[myFiles, setMyFiles]);

	const handleSelect = useCallback(
		(items) => {
			const newFiles = items.filter((item) => item instanceof File);
			const existing = items.filter((item) => !(item instanceof File));

			if (newFiles.length) {
				setMyFiles((prev) => [...prev, ...newFiles].slice(0, MAX_FILES));
			}
			if (existing.length) {
				setGlobalFiles((prev) => [...prev, ...existing].slice(0, MAX_FILES));
			}
		},
		[setMyFiles, setGlobalFiles]
	);

	const openFileManager = () => {
		openAttachFileModal({
			multiple: true,
			maxFiles: Math.max(MAX_FILES - totalFiles, 1),
			onSelect: handleSelect,
		});
	};

	const { getRootProps, getInputProps } = useDropzone({
			maxFiles: MAX_FILES,
			onDrop,
			maxSize: 104857600,
			disabled: !profile?.info_verified,
			noClick: true,
			noKeyboard: true,
		});
	
	const removeFiles = (name) => {
		setMyFiles((prev) => prev.filter((el) => el.name !== name));
	};

	const removeGlobalFiles = (name) => {
		setGlobalFiles((prev) => prev.filter((el) => el.name !== name));
	};

	return (
		<SettingRow title={'Образование'} subtitle={'Здесь вы можете прикрепить документы об образовании'} disabled={!info_verified}>
			<div className={s.educationWrapper} {...getRootProps()}>
					<div className={classNames(s.filesWrapper)}>
						{(myFiles?.length > 0 || globalFiles?.length > 0) &&
							[...myFiles, ...globalFiles].map((el) => (
								<div className={s.fileWrapper}>
									{el.name.length > 10
										? el.name.slice(0, 7) + "..."
										: el.name}
									{info_verified ? <button
										className={s.removeBtn}
										onClick={() => el.attachable_type ? removeGlobalFiles(el.name) : removeFiles(el.name)}
									>
										<IconX size={16} />
									</button> : ''}
								</div>
							))}
					</div>
					<input {...getInputProps()} />
					<Button
						label={<IconPaperclip size={16} />}
						size="small"
						className={s.plusBtn}
						disabled={!profile?.info_verified}
						onClick={openFileManager}
					/>
				</div>
				{profile?.teacher_education?.filter(n => n).length ? 
				<ul className={s.education}>
					{profile?.teacher_education?.map((e) => (
						<li className={s.educationContent}>
							{e}
						</li>
					))}
					</ul> : null}
		</SettingRow>
	)
}
